import NumberFormat from "react-number-format";

function CurrencyFormat({ value }) {
  // TODO: switch to using `Number.isNaN`
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) {
    return null;
  }

  return (
    <NumberFormat
      thousandSeparator
      value={value.toFixed(2)}
      prefix="$"
      displayType="text"
    />
  );
}

export { CurrencyFormat };
